import { render } from "./PropertyHeader.vue?vue&type=template&id=4c25c932"
import script from "./PropertyHeader.vue?vue&type=script&lang=js"
export * from "./PropertyHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__